import { expVal } from '@confluence/feature-experiments';
import { getBrowserTabId } from '@confluence/graphql/entry-points/getBrowserTabId.ts';

type ShouldSkipOwnPubSubEventArgs = {
	accountId?: string | null;
	currentUserId?: string | null;
	originTabId?: string | null;
	isReply?: boolean;
	isOwnReplyPubSubProcessingEnabled?: boolean;
};

export const shouldSkipOwnPubSubEvent = ({
	accountId = null,
	currentUserId = null,
	originTabId = null,
	isReply = false,
	isOwnReplyPubSubProcessingEnabled = false,
}: ShouldSkipOwnPubSubEventArgs): boolean => {
	if (expVal('cc_use_browser_tab_id', 'isEnabled', false)) {
		return originTabId === getBrowserTabId();
	}

	if (!accountId || accountId !== currentUserId) {
		return false;
	}

	// Agents comment through public APIs, so their events reach the frontend as current-user
	// events; processing own replies is the workaround for that until the originating tab is used.
	if (!isReply) {
		return true;
	}

	return !isOwnReplyPubSubProcessingEnabled;
};
